import {AirtablePromotionItem} from '../models/airtable';

export const getEnterHereButtonText = (promotion: AirtablePromotionItem) =>
  promotion.game?.enterText || promotion.adhocButtonText || 'ENTER HERE';
